import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectVideoMemberByName } from 'flow/selectors/video-selectors';
import useRemoteScreenShareStream from 'flow/hooks/useRemoteScreenShareStream';
import { sliceUUIDFromUserName } from 'flow/utils/meeting-utils';
import { FeedMember, memberDisplayName } from '../meeting-tile-utils';
import TileStageScreenShare from './TileStageScreenShare';

interface TileRemoteStageScreenShareProps {
    /** The presenting member (feed entry) whose screen owns the stage. */
    member: FeedMember;
}

/** A remote presenter's shared screen on the stage. Resolves the screen stream
 * off their primary peer and hands it to the shared tile. */
const TileRemoteStageScreenShare: React.FC<TileRemoteStageScreenShareProps> = ({
    member,
}) => {
    const displayName = memberDisplayName(member);
    const videoMember = useAppSelector((state) =>
        selectVideoMemberByName(state, displayName),
    );
    const { stream, sourceKey } = useRemoteScreenShareStream(videoMember);

    return (
        <TileStageScreenShare
            stream={stream}
            presenterName={sliceUUIDFromUserName(displayName)}
            sourceKey={sourceKey}
            // The raw signaling name (UUID and all) — it is the key the stats
            // collector registered the presenter's primary leg under, and that
            // leg is the shared screen for the duration of the share.
            statsMemberName={displayName}
        />
    );
};

export default React.memo(TileRemoteStageScreenShare);
